/* NJC PDP UPSELL BUNDLE */

(() => {
  function initUpsell(root = document) {
    root.querySelectorAll('[data-j-upsell-bundle]').forEach(bundle => {
      if (bundle.dataset.initialized === 'true') return;
      bundle.dataset.initialized = 'true';

      const select = bundle.querySelector('[data-j-upsell-variant]');
      const button = bundle.querySelector('[data-j-upsell-add]');
      const price = bundle.querySelector('[data-j-upsell-price]');
      const status = bundle.querySelector('[data-j-upsell-status]');

      if (!button) return;

      if (select) {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];

          if (price && option.dataset.price) {
            price.textContent = `(${option.dataset.price})`;
          }
        });
      }

      button.addEventListener('click', async () => {
        const variantId = select
          ? select.value
          : button.dataset.defaultVariant;

        if (!variantId) return;

        button.disabled = true;

        if (status) status.textContent = 'Adding…';

        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: Number(variantId),
                  quantity: 1
                }]
              })
            }
          );

          if (!response.ok) throw new Error('Unable to add upsell');

          await response.json();

          if (status) status.textContent = 'Added to cart.';

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );

        } catch (error) {
          if (status) {
            status.textContent = 'Unable to add. Please try again.';
          }
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUpsell());
  } else {
    initUpsell();
  }

  document.addEventListener('shopify:section:load', event => {
    initUpsell(event.target);
  });
})();


/* ==========================================================
   NJC PRODUCT — HOW TO USE TABS
   ========================================================== */

(() => {

  function initInstructions(root = document) {

    root.querySelectorAll('[data-j-instructions]').forEach(component => {

      if (component.dataset.initialized === 'true') return;

      component.dataset.initialized = 'true';

      const tabs = component.querySelectorAll('[data-j-instructions-tab]');
      const panels = component.querySelectorAll('[data-j-instructions-panel]');

      tabs.forEach(tab => {

        tab.addEventListener('click', () => {

          const target = tab.dataset.jInstructionsTab;

          tabs.forEach(item => {
            const active = item === tab;

            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(panel => {

            const active =
              panel.dataset.jInstructionsPanel === target;

            panel.classList.toggle('is-active', active);
            panel.hidden = !active;


            /* Pause local video when leaving video tab */

            if (!active) {
              const video = panel.querySelector('video');

              if (video) {
                video.pause();
              }
            }

          });

        });

      });

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initInstructions()
    );

  } else {

    initInstructions();

  }


  document.addEventListener(
    'shopify:section:load',
    event => initInstructions(event.target)
  );

})();


/* ==========================================================
   NJC PRODUCT — FAQ
   ========================================================== */

(() => {

  function initFaq(root = document) {

    root.querySelectorAll('[data-j-faq]').forEach(component => {

      if (component.dataset.initialized === 'true') return;

      component.dataset.initialized = 'true';

      const triggers = component.querySelectorAll('[data-j-faq-trigger]');

      triggers.forEach(trigger => {

        trigger.addEventListener('click', () => {

          const answerId = trigger.getAttribute('aria-controls');
          const answer = component.querySelector(`#${answerId}`);
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';

          triggers.forEach(otherTrigger => {

            const otherAnswerId = otherTrigger.getAttribute('aria-controls');
            const otherAnswer = component.querySelector(`#${otherAnswerId}`);

            otherTrigger.setAttribute('aria-expanded', 'false');

            if (otherAnswer) {
              otherAnswer.hidden = true;
            }

          });

          if (!isOpen) {
            trigger.setAttribute('aria-expanded', 'true');

            if (answer) {
              answer.hidden = false;
            }
          }

        });

      });

    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaq());
  } else {
    initFaq();
  }

  document.addEventListener('shopify:section:load', event => {
    initFaq(event.target);
  });

})();


document.addEventListener('click', function (event) {
  const continueButton = event.target.closest('[data-j-cart-close]');

  if (!continueButton) return;

  const drawer = continueButton.closest('.t4s-drawer');

  const closeButton = drawer?.querySelector(
    '.t4s-drawer__close, [data-drawer-close]'
  );

  if (closeButton) {
    closeButton.click();
  }
});